import React from "react";
import classNames from "classnames";
import moment from "moment";
import { Button } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import FormatDate, { defaultFormatDate } from "go-core/components/Formatters/FormatDate";
import { useWindowSize } from "go-core/components/useWindowSize";
import { useConfirmation } from "go-form/components/ModalConfirm";
import { KSeFCertificateIssuedInfoProps } from "../../utils/types";

export const KSeFCertificateIssuedInfo = ({
	createdAt,
	activeUntil,
	setValue,
	removeKey,
}: KSeFCertificateIssuedInfoProps) => {
	const { t } = useTranslation();
	const { isSmallBreakpoint } = useWindowSize();
	const certificateExpired = moment().isAfter(activeUntil);
	const confirmation = useConfirmation();
	const { addFlash } = useFlash();

	const removeButtonClickHandler = async () => {
		try {
			await confirmation({
				title: t("lib:confirmation.title"),
				message: t("lib:confirmation.message.remove"),
			});
			setValue(removeKey, true);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	return (
		<div className="d-flex flex-column mb-4" data-testid={`KSeF-certificate-issue-info-${removeKey}`}>
			<p className={classNames("my-4 w-50 align-self-center text-center", { "w-75": isSmallBreakpoint })}>
				{certificateExpired ? (
					t("modules.invoice_details.field.expired_certificate_details.title", {
						createdAt: FormatDate(createdAt, undefined, undefined, defaultFormatDate),
						activeUntil: FormatDate(activeUntil, undefined, undefined, defaultFormatDate),
					})
				) : (
					<Trans
						i18nKey="modules.invoice_details.field.valid_certificate_details.title"
						values={{
							createdAt: FormatDate(createdAt, undefined, undefined, defaultFormatDate),
							activeUntil: FormatDate(activeUntil, undefined, undefined, defaultFormatDate),
						}}
						components={{ successText: <span className="text-success" /> }}
					/>
				)}
			</p>
			<Button variant="danger" onClick={removeButtonClickHandler} className="align-self-start">
				{t("lib:common.action.remove")}
			</Button>
		</div>
	);
};
